import { fireImpression } from '@vp/ab-reader'
import type { ExperimentTest } from '../node/experiments'

const trackedTests: string[] = []

export default async function trackImpression(tests: ExperimentTest[], userTests?: ExperimentTest[]) {
  if (!userTests) {
    return
  }

  /*
      The data structure for node level ab tests and site header level ab tests is different.
      Thus, we are implementing this hotfix to accommodate both data structures.
    */
  const siteHeaderLevelExperiments = tests?.map((test) => test?.Experiment)?.filter((experiment) => experiment)
  const matchingTests = userTests.filter((userTest) => {
    return (
      (tests?.some((test) => test.Experiment === userTest.Experiment) || siteHeaderLevelExperiments?.includes(userTest.Experiment)) &&
      !trackedTests.includes(userTest.Experiment)
    )
  })

  if (matchingTests.length === 0) {
    return
  }

  matchingTests.forEach(async (matchingTest) => {
    trackedTests.push(matchingTest.Experiment)
    await fireImpression(matchingTest.Experiment, matchingTest.Variation)
  })
}
